import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ChevronDown",
  "use": "ChevronDown-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"ChevronDown\">\n  <path d=\"M4.94 5.727 8 8.78l3.06-3.053.94.94-4 4-4-4 .94-.94Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol